module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-preview-container",
    class: {
      'has-avatar': !_vm.isDefaultAvatar
    }
  }, [_c('div', {
    staticClass: "wrapper-preview-container",
    style: ({
      height: _vm.previewCardHeight + 'px'
    })
  }, [_c('div', {
    ref: "previewCardWrapper",
    staticClass: "wrapper-preview",
    style: ({
      transform: 'scale(' + _vm.previewCardScale + ')'
    })
  }, [_c('card-content', {
    ref: "previewCard",
    attrs: {
      "type": _vm.type,
      "name": _vm.name,
      "date": _vm.date,
      "custom-title": _vm.customTitle,
      "top-src": _vm.topImageData,
      "bottom-src": _vm.bottomImageData,
      "avatar-src": _vm.avatarImageData
    }
  }), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "form__file"
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.onSelectFile('avatar', $event.target)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "form__file--bg"
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.onSelectFile('top', $event.target)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editing && (_vm.topImageSrc.startsWith('http') || this.files.top)) ? _c('div', {
    staticClass: "remove-file"
  }, [_c('i', {
    staticClass: "fas fa-trash-alt"
  }), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeTopImage.apply(null, arguments)
      }
    }
  }, [_vm._v(" ลบภาพ")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "preview-edit"
  }, [(_vm.showEditLink && !_vm.editMode) ? _c('a', {
    staticClass: "pull-right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.edit.apply(null, arguments)
      }
    }
  }, [_vm._v("แก้ไข")]) : _vm._e(), _vm._v(" "), (_vm.showEditLink && _vm.editMode) ? _c('a', {
    staticClass: "pull-right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel.apply(null, arguments)
      }
    }
  }, [_vm._v("ยกเลิก")]) : _vm._e()])]), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "capture-image-wrapper"
  }, [_c('div', {
    ref: "captureCard",
    staticClass: "capture-image"
  }, [_c('card-content', {
    ref: "capturePageCard",
    attrs: {
      "type": _vm.type,
      "name": _vm.name,
      "date": _vm.date,
      "custom-title": _vm.customTitle,
      "top-src": _vm.topImageData,
      "bottom-src": _vm.bottomImageData,
      "avatar-src": _vm.avatarImageData
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "captureCanvas",
    staticClass: "capture-canvas"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df3f1580","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/pages/special-events/card.vue
// module id = 1144
// module chunks = 1